import { Component, OnInit } from '@angular/core';
import { ModalService } from 'src/app/shared/services/modal.service';

import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ExameFormComponent } from '../exame-form/exame-form.component';
import { Store } from '@ngrx/store';
import { exameActions } from 'src/app/store/exame/exame.actions';
import { selectExamLoading, selectExamState, selectExamTotalItems, selectExameLista } from 'src/app/store/exame/exame.selectors';
import { IExame } from 'src/app/shared/interfaces/exames/iexame';
import { ExameFilter, ExameService } from 'src/app/shared/services/exame.service';

@Component({
  selector: 'app-exame-lista',
  templateUrl: './exame-lista.component.html',
  styleUrls: ['./exame-lista.component.scss']
})
export class ExameListaComponent implements OnInit {

  filter = new ExameFilter();
  mostrarModalDeletar: boolean = false;
  mostrarModalInativar: boolean = false;
  mostrarModalAtivar: boolean = false;
  totalRecords = 0;

  ref: DynamicDialogRef | undefined;

  selectedItemId: number = 9999999999;
  selectedItem: any
  isLoading$ = this.store.select(selectExamLoading)
  lista$ = this.store.select(selectExameLista)
  selectExamState$ = this.store.select(selectExamState)
  selectTotalItems$ = this.store.select(selectExamTotalItems)
  constructor(
    public modalService: ModalService,
    public dialogService: DialogService,
    public examService: ExameService,
    private store: Store
  ) { }

  filterName(name : string) {
    this.filter.name = name;
    this.examService.setFilter(this.filter);
    this.store.dispatch(exameActions.loadExame());
  }
  
  ngOnInit(): void {
    // this.selectExamState$.subscribe(res => {
    //   //console.log('state: ', res)
    // })
    //this.isLoading$.subscribe((res) => { console.log('isloading: ', res)})

    this.examService.setFilter({ 
      unit: [],
      name: '',
      page: '1'
    })
    this.store.dispatch(exameActions.loadExame())
    
     this.selectTotalItems$.subscribe({
       next: (res: any) => { 
        this.totalRecords = res.total
      },
      error: (error: any) => console.log(error)
     })

  }

  cadastrarExame() {
    this.modalService.calledfor('cadastrar');
    this.modalService.show(ExameFormComponent, 'Cadastro de Exames')
  }

  editarExame(exame: IExame) {
    this.modalService.calledfor('editar');
    this.modalService.show(ExameFormComponent, 'Editar Exame', exame);
  }

  inativarExame(item: any) {
    this.mostrarModalInativar = !this.mostrarModalInativar

    this.selectedItem = item
  }

  inativarExamePatch() {
    let req = { ...this.selectedItem }
    req.active = false;
    req.unit =req.unit['@id'];
    //console.log(req)

    this.store.dispatch(exameActions.editExame({ exame: req, id: req.id }))
    this.fecharDialog()
  }

  ativarExame(item: any) {
    this.mostrarModalAtivar = !this.mostrarModalAtivar

    this.selectedItem = item
  }

  ativarExamePatch() {
    let req = { ...this.selectedItem }
    req.active = true;
    req.unit =req.unit['@id'];
    //console.log(req)

    this.store.dispatch(exameActions.editExame({ exame: req, id: req.id }))
    this.fecharDialog()

  }

  deletarExame(id: number) {
    this.mostrarModalDeletar = !this.mostrarModalDeletar

    this.selectedItemId = id
  }

  onDelete() {

    this.store.dispatch(exameActions.deleteExame({ id: this.selectedItemId }))
    this.fecharDialog()
  }


  public fecharDialog() {
    this.ref?.destroy()

    this.mostrarModalDeletar = false
    this.mostrarModalInativar = false
    this.mostrarModalAtivar = false

  }

  onPageChange(event: any) {
    this.examService.setFilter({ 
      unit: [],
      name: '',
      page: event.page 
    })
    this.store.dispatch(exameActions.loadExame())
  }

  /* mock */

  filters: Array<any> = [
    {
      id: "unit",
      type: "DROPDOWN",
      name: "Unidade",
      data: [
        {
          value: "Cachoeiro de Itapemirim",
          code: 1  /* true */
        },
        {
          value: "Contagem",
          code: 2 /* false */
        },
        {
          value: "Vitória",
          code: 2 /* false */
        },
        {
          value: "Belo Horizonte",
          code: 2 /* false */
        }
      ]
    }
  ]
}
